/**
 * @generated SignedSource<<ab0606ed4cb66ef746ef1838fe954070>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetEmailTemplatePrimaryLanguageInput = {
  id: string;
  primaryLanguage: string;
};
export type EmailTemplateDetailsViewSetPrimaryLanguageMutation$variables = {
  input: SetEmailTemplatePrimaryLanguageInput;
};
export type EmailTemplateDetailsViewSetPrimaryLanguageMutation$data = {
  readonly setEmailTemplatePrimaryLanguage: {
    readonly id: string;
    readonly primaryLanguage: string;
  };
};
export type EmailTemplateDetailsViewSetPrimaryLanguageMutation = {
  response: EmailTemplateDetailsViewSetPrimaryLanguageMutation$data;
  variables: EmailTemplateDetailsViewSetPrimaryLanguageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailTemplate",
    "kind": "LinkedField",
    "name": "setEmailTemplatePrimaryLanguage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryLanguage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplateDetailsViewSetPrimaryLanguageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailTemplateDetailsViewSetPrimaryLanguageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bec5de7a8c658658e7e6c0564f8065c0",
    "id": null,
    "metadata": {},
    "name": "EmailTemplateDetailsViewSetPrimaryLanguageMutation",
    "operationKind": "mutation",
    "text": "mutation EmailTemplateDetailsViewSetPrimaryLanguageMutation(\n  $input: SetEmailTemplatePrimaryLanguageInput!\n) {\n  setEmailTemplatePrimaryLanguage(input: $input) {\n    id\n    primaryLanguage\n  }\n}\n"
  }
};
})();

(node as any).hash = "d577656ad116a11d382489484dbec50d";

export default node;
